<template>
  <div class="OutsideSettle">
    <div class="top">
      <Menu mode="horizontal" ref="slideMenu" :active-name="menu">
          <MenuItem :name="index+''" :to="p.url" v-for="(p,index) in navItems" :key="index">
            <Badge :count="p.count" type="error">
              <Icon :custom="p.icon" />
              {{p.menuName}}
            </Badge>
          </MenuItem>
      </Menu>
    </div>
    <div class="main">
      <router-view/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'OutsideSettle',
  data () {
    return {
      navItems:[],
      menu:'0'
    }
  },
  mounted(){
    this.$nextTick(()=>{
      // this.menu = this.$route.path.slice(1)
      this.$refs.slideMenu.updateOpened()
      this.$refs.slideMenu.updateActiveName();
    })
    this.getCount();
    this.getItem();
  },
  methods:{
    getCount(){
    },
    getItem(){
      let data = [
        {icon:' iconfont icon-daizhifu',sn:'1',menuName:'未结算',url:'/nopay',count:0},
        {icon:' iconfont icon-jiesuan',sn:'2',menuName:'结算中',url:'/inpay',count:0},
        {icon:' iconfont icon-yizhifu',sn:'3',menuName:'已结算',url:'/havepay',count:0}
      ];
      this.navItems = data;
      // this.$emit('showNavItems',this.navItems);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
 
.OutsideSettle{
  overflow: scroll;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/views/outsidesettle/OutsideSettle.vue